import styled from 'styled-components';
import { Text18Medium, Text24Medium, Text48Medium } from '../../mixins/mixins';

const DescriptionComponent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  background: rgba(28, 99, 255, 1);
  padding: 120px 24px 63px;
  @media (max-width: 669px) {
    padding: 120px 12px 96px;
  }
`;

const TitleDescription = styled.div`
  width: 390px;
  ${Text48Medium};
  @media (max-width: 669px) {
    ${Text24Medium};
    width: 215px;
  }
`;

const PostWrapper = styled.div`
  display: flex;
  margin-top: 64px;
  @media (max-width: 669px) {
    margin-top: 32px;
    flex-direction: column;
    width: 296px;
  }
`;

const Post = styled.div`
  width: 320px;
  ${Text18Medium};
  margin-right: 142px;
  color: rgba(255, 255, 255, 0.6);
  @media (max-width: 669px) {
    margin-top: 32px;
    width: 296px;
    :first-child {
      margin-top: 0;
    }
  }
`;

const ArrowLink = styled.a`
  position: absolute;
  bottom: 72px;
  right: 25px;
  width: 14px;
  height: 16px;
  cursor: pointer;
  @media (max-width: 669px) {
    left: 21px;
    bottom: 40px;
    right: unset;
  }
`;

const Description = () => (
    <DescriptionComponent id="start">
        <TitleDescription>A bridge to the Asian market</TitleDescription>
        <PostWrapper>
            <Post>
                LaoHe - supply of goods for the wholesale and retail trade from the
                manufacturers in China and Hong Kong.
            </Post>
            <Post>
                We cooperate with manufacturers of electronics and consumer goods. Our
                logistics partners provide reliability during the transportation of
                goods.
            </Post>
        </PostWrapper>
        <ArrowLink href={'/#cities'}>
            <img src="/assets/img/DescriptionImages/Vector.png" alt="Vector" />
        </ArrowLink>
    </DescriptionComponent>
);

export default Description;
